export enum EVENTS {
    APPLY_SUBMIT_LETS_GET_STARTED = "web:apply:submit_lets_get_started",
    APPLY_SUBMIT_BUSINESS_INFO = "web:apply:submit_business_info",
    APPLY_SUBMIT_OFFICER_INFO = "web:apply:submit_officer_info",
    APPLY_SUBMIT_APPLICATION = "web:apply:submit_application",
    APPLY_CLICK_ADD_BENEFICIAL_OWNER = "web:apply:click_add_beneficial_owner",
    APPLY_APPLICATION_RESULT = "apply:application_result",
    APPLY_CLICK_GO_TO_MY_ACCOUNT = "web:apply:click_go_to_my_account",
    CARD_ACTIVATE = "web:card:activate",
    CARD_ACTIVATE_ERROR = "web:card:activate_error",
    CARD_SET_PIN = "web:card:set_pin",
    CARD_RESET_PIN = "web:card:reset_pin",
    CARD_PIN_ERROR = "web:card:pin_error",
}

// TODO(@lucaslemanowicz) - Migrate to actually use @segment/analytics-next package
declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        analytics: any;
    }
}

/**
 * @see https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#basic-tracking-methods.
 */
export const Segment = {
    // We still have to use `?` in case of SSR or if segment hasn't loaded yet
    page: (name?: string, props?: object) => {
        window?.analytics?.page(name, props);
    },
    /**
     * @deprecated Use `logEvent` instead.
     */
    track: (name: string, props?: object) => {
        window?.analytics?.track(name, props);
    },
    identify: (userId: string, props?: object) => {
        window?.analytics?.identify(userId, props);
    },
    reset: () => window?.analytics?.reset(),
};
